import { fundTransferConstants } from "../_constants";

export const fundTransferpayFromListRequest = (payload) => {
  return {
    type: fundTransferConstants.FUND_TRANSFER_PAY_FROM_LIST_REQUEST,
    payload,
  };
};

export const fundTransferpayFromListComplete = (payload) => {
  return {
    type: fundTransferConstants.FUND_TRANSFER_PAY_FROM_LIST_COMPLETE,
    payload,
  };
};

export const fundTransferpayFromListError = (payload) => {
  return {
    type: fundTransferConstants.FUND_TRANSFER_PAY_FROM_LIST_ERROR,
    payload,
  };
};

export const fundTransferpayToListRequest = (payload) => {
  return {
    type: fundTransferConstants.FUND_TRANSFER_PAY_TO_LIST_REQUEST,
    payload,
  };
};

export const fundTransferpayToListComplete = (payload) => {
  return {
    type: fundTransferConstants.FUND_TRANSFER_PAY_TO_LIST_COMPLETE,
    payload,
  };
};

export const fundTransferpayToListError = (payload) => {
  return {
    type: fundTransferConstants.FUND_TRANSFER_PAY_TO_LIST_ERROR,
    payload,
  };
};

export const fundTransferOwnInitializeRequest = (payload) => {
  return {
    type: fundTransferConstants.FUND_TRANSFER_OWN_INITIALIZE_REQUEST,
    payload,
  };
};

export const setFundTransferOwnData = (payload) => {
  return {
    type: fundTransferConstants.SET_FUND_TRANSFER_OWN_FORM_DATA,
    payload,
  };
};

export const fundTransferOwnInitializeComplete = (payload) => {
  return {
    type: fundTransferConstants.FUND_TRANSFER_OWN_INITIALIZE_COMPLETE,
    payload,
  };
};

export const fundTransferOwnInitializeError = (payload) => {
  return {
    type: fundTransferConstants.FUND_TRANSFER_OWN_INITIALIZE_ERROR,
    payload,
  };
};

export const clearFundTransferForms = (payload) => {
  return {
    type: fundTransferConstants.CLEAR_FUND_TRANSFER_FORMS,
    payload,
  };
};

export const clearFundTransferInitialization = (payload) => {
  return {
    type: fundTransferConstants.CLEAR_FUND_TRANSFER_INTIALIZATION,
    payload,
  };
};

export const favouriteClearFundTransferInitialization = (payload) => {
  return {
    type: fundTransferConstants.FAVOURITE_CLEAR_FUND_TRANSFER_INTIALIZATION,
    payload,
  };
};

export const fundTransferCurrencyConvertionRequest = (payload) => {
  return {
    type: fundTransferConstants.FUND_TRANSFER_CURRENCY_CONVERTION_REQUEST,
    payload,
  };
};

export const fundTransferCurrencyConvertionComplete = (payload) => {
  return {
    type: fundTransferConstants.FUND_TRANSFER_CURRENCY_CONVERTION_COMPLETE,
    payload,
  };
};

export const fundTransferCurrencyConvertionError = (payload) => {
  return {
    type: fundTransferConstants.FUND_TRANSFER_CURRENCY_CONVERTION_ERROR,
    payload,
  };
};

export const fundTransferOTPRequest = (payload) => {
  return {
    type: fundTransferConstants.FUND_TRANSFER_OTP_REQUEST,
    payload,
  };
};

export const fundTransferOTPComplete = (payload) => {
  return {
    type: fundTransferConstants.FUND_TRANSFER_OTP_COMPLETE,
    payload,
  };
};

export const fundTransferOTPError = (payload) => {
  return {
    type: fundTransferConstants.FUND_TRANSFER_OTP_ERROR,
    payload,
  };
};

export const fundTransferProceedRequest = (payload) => {
  return {
    type: fundTransferConstants.FUND_TRANSFER_PROCEED_REQUEST,
    payload,
  };
};

export const fundTransferProceedComplete = (payload) => {
  return {
    type: fundTransferConstants.FUND_TRANSFER_PROCEED_COMPLETE,
    payload,
  };
};

export const fundTransferProceedError = (payload) => {
  return {
    type: fundTransferConstants.FUND_TRANSFER_PROCEED_ERROR,
    payload,
  };
};

export const fundTransferBankListRequest = (payload) => {
  return {
    type: fundTransferConstants.FUND_TRANSFER_BANK_LIST_REQUEST,
    payload,
  };
};

export const fundTransferBankListComplete = (payload) => {
  return {
    type: fundTransferConstants.FUND_TRANSFER_BANK_LIST_COMPLETE,
    payload,
  };
};

export const fundTransferBankListError = (payload) => {
  return {
    type: fundTransferConstants.FUND_TRANSFER_BANK_LIST_ERROR,
    payload,
  };
};

export const fundTransferAccountDetailRequest = (payload) => {
  return {
    type: fundTransferConstants.FUND_TRANSFER_VALIDATE_ACCOUNT_DETAIL_REQUEST,
    payload,
  };
};

export const fundTransferAccountDetailComplete = (payload) => {
  return {
    type: fundTransferConstants.FUND_TRANSFER_VALIDATE_ACCOUNT_DETAIL_COMPLETE,
    payload,
  };
};

export const fundTransferAccountDetailError = (payload) => {
  return {
    type: fundTransferConstants.FUND_TRANSFER_VALIDATE_ACCOUNT_DETAIL_ERROR,
    payload,
  };
};
